import { useInfiniteQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";

export const fetchClientsData = async ({ queryKey, pageParam = 1 }) => {
  const { search, filterData, sortBy, order, timeline } = queryKey[1];

  const res = await apiClient.post(`/api/v9/myBinnys/getAllClients`, {
    page: pageParam,
    limit: 200,
    search,
    filterData: filterData || [],
    sortBy, 
    order,
    timeline,
  });

  return res.data?.data;
};
